import React from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { RefreshCw, AlertCircle } from 'lucide-react';

interface SessionRecoveryToastProps {
  onRetry: () => void;
  onRefresh: () => void;
}

export const SessionRecoveryToast = ({ onRetry, onRefresh }: SessionRecoveryToastProps) => {
  return (
    <div className="flex flex-col gap-3 p-2">
      <div className="flex items-center gap-2 text-amber-800">
        <AlertCircle className="w-4 h-4" />
        <span className="font-medium">Session-Problem erkannt</span>
      </div>
      <p className="text-sm text-amber-700">
        Ihre Sitzung ist möglicherweise abgelaufen. Versuchen Sie eine der folgenden Optionen:
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={onRetry}
          className="flex-1 text-xs"
        >
          <RefreshCw className="w-3 h-3 mr-1" />
          Erneut versuchen
        </Button>
        <Button
          size="sm"
          onClick={onRefresh}
          className="flex-1 text-xs bg-amber-600 hover:bg-amber-700"
        >
          Seite aktualisieren
        </Button>
      </div>
    </div>
  );
};

// Utility-Funktion zum Anzeigen des Session-Recovery-Toasts
export const showSessionRecoveryToast = (onRetry: () => void) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  toast.error(
    <SessionRecoveryToast onRetry={onRetry} onRefresh={handleRefresh} />,
    {
      duration: 10000,
      position: 'top-center',
      className: 'w-auto max-w-md',
      style: {
        background: 'linear-gradient(to right, #fef3c7, #fde68a)',
        border: '1px solid #f59e0b',
        borderRadius: '12px',
        padding: '16px'
      }
    }
  );
};

// Hook für automatische Session-Recovery
export const useSessionRecovery = () => {
  const handleSessionError = (retryFunction: () => void) => {
    showSessionRecoveryToast(retryFunction);
  };

  return { handleSessionError };
}; 